import { fetchWithAuth } from "./api";
import {
  Patient,
  CreatePatientPayload,
  UpdatePatientPayload,
  PatientResponse,
  PatientsResponse,
} from "types/patient";

const API_URL = process.env.REACT_APP_API_URL;

export const patientService = {
  getPatients: async (): Promise<PatientsResponse> => {
    try {
      const response = await fetchWithAuth(`/patients`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  getPatient: async (id: number): Promise<PatientResponse> => {
    try {
      const response = await fetchWithAuth(`/patients/${id}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  createPatient: async (
    patient: CreatePatientPayload
  ): Promise<PatientResponse> => {
    try {
      const response = await fetchWithAuth("/patients", {
        method: "POST",
        body: JSON.stringify(patient),
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  updatePatient: async (
    id: number,
    patient: UpdatePatientPayload
  ): Promise<PatientResponse> => {
    try {
      const response = await fetchWithAuth(`/patients/${id}`, {
        method: "PUT",
        body: JSON.stringify(patient),
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  deletePatient: async (id: number): Promise<PatientResponse> => {
    try {
      const response = await fetchWithAuth(`/patients/${id}`, {
        method: "DELETE",
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  togglePatientStatus: async (id: number): Promise<PatientResponse> => {
    try {
      const response = await fetchWithAuth(`/patients/${id}/toggle-status`, {
        method: "PATCH",
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  resendQuestionnaires: async (
    assignmentId: number
  ): Promise<{ success: boolean; message: string }> => {
    try {
      const response = await fetchWithAuth(
        `/questionnaire-assignments/${assignmentId}/resend`,
        {
          method: "POST",
          body: JSON.stringify({
            delivery: ["email", "whatsapp"],
          }),
        }
      );
      return response;
    } catch (error) {
      throw error;
    }
  },

  deleteQuestionnaireAssignment: async (
    assignmentId: number
  ): Promise<PatientResponse> => {
    try {
      const response = await fetchWithAuth(
        `/questionnaire-assignments/${assignmentId}`,
        {
          method: "DELETE",
        }
      );
      return response;
    } catch (error) {
      throw error;
    }
  },
};
